<template>
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="7" r="3" stroke="currentColor" stroke-width="1.4" fill="none" />
    <path
      d="M3 17c1.5-3.5 4.2-5 7-5s5.5 1.5 7 5"
      stroke="currentColor"
      stroke-width="1.4"
      fill="none"
      stroke-linecap="round"
    />
  </svg>
</template>
